import { Action } from "../../../../../types/state/action";
import {
  ILicensedProperty,
  ILicensor,
} from "../../../../../types/data.interface";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

export type CreateArtworkCollectionState = {
  id?: number;
  name: string;
  code: string;
  year: string;
  image: any;
  image_base64?: any;
  requesting_market: {
    full_name: string;
    id: string;
    short_name: string;
  };
  licensor: ValueOrNull<ILicensor>;
  licensed_property: ValueOrNull<ILicensedProperty>;
  launch_date: string;
  status: ValueOrNull<{id:number, name:string}>;
  submitComment: string;
  reject_reason?: any;
  isReadOnly:boolean;
  history: {
    id: number,
    date: string,
    comment: string,
    status_reason: string,
    status: number,
    collection: number,
    requester: string,
    revisor: string,
    approver: string
  }[];
  isValid: boolean;
};

export enum CreateArtworkCollectionTypes {
  SET_ARTWORK_COLLECTION = "setArtworkCollection",
  SET_NAME = "name",
  SET_CODE = "code",
  SET_YEAR = "year",
  SET_IMAGE = "image",
  SET_IMAGE_BASE64 = "image_base64",
  SET_REQUESTING_MARKET = "requesting_market",
  SET_LICENSOR = "licensor",
  SET_LAUNCH_DATE = "launch_date",
  SET_LICENSED_PROPERTY = "licensed_property",
  SET_STATUS = "status",
  SET_SUBMIT_COMMENT = "submitComment",
  SET_IS_READ_ONLY = "isReadOnly",
  SET_REJECT_REASON = "reject_reason",
  SET_IS_VALID = "isValid",
  RESET = "reset",
}

export type CreateArtworkCollectionType = Action<CreateArtworkCollectionTypes, Partial<CreateArtworkCollectionState>>;